import {
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output
} from '@angular/core';
import {
    getSeasonAccessCost,
    getSeasonAccessCostEntries,
    ISeasonAccessCostEntry
} from './season-access-cost';

const template = require('!!raw-loader!./dice.component.html').default;

@Component({
    selector: 'enter-dice',
    template,
    styleUrls: ['./dice.component.less'],
})
export class DiceComponent {
    @Input() current: number = 0;
    @Input() seasonAccessCost: any;
    @Input() granted: boolean = false;
    @Input() unlimited: boolean = false;
    @Input() disabled: boolean = false;

    @Output() activate: EventEmitter<void> = new EventEmitter();

    get accessCost(): number {
        return getSeasonAccessCost(this.seasonAccessCost);
    }

    get costEntries(): ISeasonAccessCostEntry[] {
        return getSeasonAccessCostEntries(this.seasonAccessCost);
    }

    trackByTimestamp(_index: number, entry: ISeasonAccessCostEntry): number {
        return entry.timestamp;
    }

    @HostBinding('class.--ready') get ready(): boolean {
        return this.granted ||
            this.unlimited ||
            (this.accessCost > 0 && this.current >= this.accessCost);
    }

    @HostBinding('class.--disabled') get isDisabled(): boolean {
        return this.disabled;
    }

    @HostBinding('attr.aria-disabled') get ariaDisabled(): string {
        return this.disabled ? 'true' : 'false';
    }

    @HostListener('click')
    onActivate(): void {
        if (!this.disabled) {
            this.activate.emit();
        }
    }
}
